module.exports = __webpack_public_path__ + "img/logoFooter.32111abd.svg";